import AddCharityModal from './AddCharityModal';
import ContentSearchPage from '../ContentSearchPage';

const options = {
  pageTitle: 'Charity Guide',
  contentType: 'product',
  pageIcon: 'gift',
  addItemModal: <AddCharityModal />,
};

const searchFields = [
  { name: 'headline', label: 'Charity name' },
  { name: 'city', label: 'City' },
  { name: 'status', label: 'Status' },
  { name: 'time', label: 'Publication date' },
];
const columns = ['photo', 'headline', 'date', 'city', 'status', 'sections'];

const CharityPage = () => <ContentSearchPage {...options} searchFields={searchFields} columns={columns} />;

export default CharityPage;
